import script from "./EventsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsPage.vue?vue&type=script&setup=true&lang=ts"

import "./EventsPage.vue?vue&type=style&index=0&id=0216d18c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0216d18c"]])

export default __exports__